// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"6fc851ec","504":"c1cc4614"}[chunkId] + ".chunk.css";
};